import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  getJudgeSummary,
  type JudgePeriodParams,
  type JudgeSummaryResponse,
} from '../services/api/judge';

export const useJudgeSummary = (params: JudgePeriodParams) =>
  useQuery<JudgeSummaryResponse>({
    queryKey: ['judge-summary', params],
    queryFn: () => getJudgeSummary(params),
    retry: false,
    placeholderData: keepPreviousData,
  });
